import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  constructor(
    private translate: TranslateService,
    private snackbar: MatSnackBar
  ) { }

  sendError(key, variables = {}, action = 'OK', duration = 8000) {
    this.open(this.translate.instant(key, variables), action, duration);
  }

  send(key, variables = {}, action = 'OK', duration?) {
    this.open(this.translate.instant(key, variables), action, duration);
  }

  open(message, action?, duration = 3000) {
    this.snackbar.open(message, action, {
      duration,
      panelClass: ['mat-snack-bar-overlay'],
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }

}
